export const allNotificationsSelector = ({ notifications }) => notifications;